<template>
    <div>
        <form v-if="auth.loginScreen === 'login'" @submit.prevent="login()">
            <div class="form-group">
                <label>Username</label>
                <input v-model="model.username" type="text" class="form-control" placeholder="please enter your phone number">
            </div>
            <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                    <label class="mg-b-0-f">Password</label>
                    <router-link to="/forgot-password" class="tx-13">Forgot password?</router-link>
                </div>
                <input v-model="model.password" minlength="6" type="password" class="form-control" placeholder="Enter your password">
                <base-button
                        class="mt-3"
                        :loading="auth.authLoading"
                        title="Sign In"
                ></base-button>
            </div>
        </form>

        <form v-if="auth.loginScreen === 'otp'" @submit.prevent="completeEnrolment()">
            <div class="form-group">
                <label>OTP</label>
                <input v-model="model.token" name="token" type="text" class="form-control" placeholder="please enter otp">
            </div>
            <div class="form-group">
                <label class="mg-b-0-f">Password</label>
                <the-mask placeholder="Enter your password..." type="password" required v-model="model.password" maxlength="6" minlength="6" :mask="['######', '######']" class="form-control" />

                <!--                <input v-model="model.password" name="password" minlength="6" type="password" class="form-control" placeholder="Enter your password">-->
            </div>
            <div class="form-group">
                <label class="mg-b-0-f">Retype Password</label>
                <!--                <router-link to="/" class="tx-13">Sign In</router-link>-->
                <the-mask placeholder="Repeat Password here..." type="password" required v-model="model.passwordConfirmation" maxlength="6" minlength="6" :mask="['######', '######']" class="form-control" />
                <!--                <input v-model="model.passwordConfirmation" minlength="6" type="password" class="form-control" placeholder="Retype your password">-->
            </div>
            <div class="form-group">
                <base-button
                        class="mt-3"
                        :loading="auth.authLoading"
                        title="Submit"
                ></base-button>
            </div>
        </form>
    </div>
</template>

<script>
    import BaseButton from "../button/BaseButton";
    import {mapState} from 'vuex';
    export default {
        name: "LogonForm",
        components: {
            // eslint-disable-next-line vue/no-unused-components
            mapState,
            BaseButton
        },
        data() {
            return {
                model: {
                    username: '',
                    password: '',
                    pin:'1234',
                    token:'',
                    createAccount:'YES',
                    uniqueRef:'',
                    countryCode: '234',
                    passwordConfirmation: '',
                    source: 'WEB',
                    subscribe: true
                },
            }
        },
        methods: {
            clicked(){
                this.$swal({
                    title: 'Custom animation with Animate.css',
                    showClass: {
                        popup: 'animated slideInLeft faster display-6'
                    },
                    hideClass: {
                        popup: 'animated slideOutRight faster display-6'
                    },
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                })
            },
            async login() {
                localStorage.clear()
                //console.log(this.auth.authLoading)
                this.model.dialogs = this.$dialogs
                await this.$store.dispatch("auth/logon", this.model, { root: false })
                if (this.auth.response.responseCode === '00') {
                    localStorage.q_auth = this.auth.response.token
                    localStorage.username = this.auth.response.mobilenumber
                    window.location.href = "/dashboard";
                    // await this.$router.push("/dashboard")
                }else if (this.auth.response.responseCode === '01'){
                    this.model.uniqueRef = this.auth.response.uniqueref
                    this.model.password = ''
                }
            },

            async completeEnrolment() {
                localStorage.clear()
                //console.log(this.auth.authLoading)
                this.model.dialogs = this.$dialogs
                await this.$store.dispatch("auth/completeEnrollment", this.model, { root: false })
                // console.log(this.auth.response);
                await this.$store.dispatch('system/updateUserInfo',null,{root:false})
                if (this.auth.response.responseCode === '00') {
                    localStorage.q_auth = this.auth.response.authorization
                    window.location.href = "/dashboard";
                    // await this.$router.push("/dashboard")
                }
                //console.log(this.auth.authLoading)
            },

            async passwordReset1() {
                await this.$store.dispatch("auth/initiateResetPassword", this.model, { root: false })
            },

            async passwordReset2() {
                await this.$store.dispatch("auth/verifyToken", this.model, { root: false })
            },

            async passwordReset3() {
                await this.$store.dispatch("auth/completeResetPassword", this.model, { root: false })
            },

        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'auth',
                'officer',
            ]),
        },
        watch: {
            'auth': function() {
                //console.log('Hello World!')
            }
        },
        mounted() {
            // this.$store.auth.watch(this.$store.getters.getN, n => {
            //     console.log('watched: ', n)
            // })
        },
    }
</script>

<style scoped>

</style>